function buocGiaTheoNgay() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Loại bơ & giá thu mua",
      content:
        'Trang này bắt buộc phải có thao tác MỖI NGÀY: đặt đơn giá (đ/kg) cho từng loại bơ trước khi nhân viên thu mua nhập phiếu. Thiếu giá hôm nay → Form thu mua cảnh báo "Chưa có giá đặt sẵn hôm nay..." và ô Đơn giá bị khoá trống, không nhập được.',
    },
    {
      target: "#tour-quan-ly-gia-theo-ngay-tabs",
      title: "Bước 2 · Hai chế độ xem",
      content:
        'Tab "Giá" để thêm/sửa loại bơ và đặt đơn giá cho một ngày cụ thể; tab "Lịch sử giá theo tháng" xem lại nhiều ngày liền, dùng mũi tên hai bên bảng để lùi/tới tháng. Bấm tiêu đề 1 cột ngày ở tab Lịch sử sẽ nhảy sang tab Giá đúng ngày đó nếu cần sửa lại.',
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-gia-theo-ngay-dat-gia",
      title: "Bước 3 · Đổi ngày để xem/đặt giá",
      content:
        'Ô "Ngày" ở đây mặc định là hôm nay — đổi sang ngày khác để xem lại giá đã đặt trước đó, hoặc đặt giá cho một ngày cụ thể (vd đặt trước giá cho ngày mai).',
      placement: "top",
    },
    {
      target: "#tour-quan-ly-gia-theo-ngay-danh-sach",
      title: "Bước 4 · Đặt giá từng loại bơ",
      content:
        "Mỗi dòng loại bơ có giá hôm qua để so sánh nhanh — nhập đơn giá rồi bấm Lưu NGAY TRÊN TỪNG DÒNG (không có nút lưu chung cho cả danh sách). Nút Sửa tên/Xoá chỉ nên dùng khi loại bơ không còn ràng buộc nghiệp vụ — xoá nhầm loại đang có giao dịch có thể ảnh hưởng dữ liệu đã ghi nhận, nên cẩn thận trước khi xoá.",
      placement: "top",
    },
    {
      target: "#tour-quan-ly-gia-theo-ngay-them-loai",
      title: "Bước 5 · Thêm loại bơ mới",
      content:
        "Việc đầu tiên khi có giống bơ mới là tạo loại ở đây trước — nhập tên rồi bấm Lưu, loại mới sẽ xuất hiện ngay trong danh sách phía trên để đặt đơn giá cho nó. Chưa đặt giá thì nhân viên thu mua chưa chọn được loại đó trong Form thu mua.",
      placement: "top",
    },
  ];
}

export default buocGiaTheoNgay;
